define(['backbone'], (Backbone) => Backbone.Model.extend({
    defaults: {
        id: null,
        name: null
    }
}));
